module.exports = __webpack_public_path__ + "8e3a922b1b4a65fbf85d16ca42c6030d.jpg";